export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 列表
    getUsedList: function getUsedList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/get",
        method: "get",
        params: data
      });
    },
    // 详情
    getUsedInfo: function getUsedInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/getInfo",
        method: "get",
        params: data
      });
    },
    // 删除
    deleteUsed: function deleteUsed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/delete",
        method: "delete",
        params: data
      });
    },
    // 推荐/取消推荐
    recommendUsed: function recommendUsed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/recommend",
        method: "post",
        data: data
      });
    },
    // 打开/关闭
    operateUsed: function operateUsed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/operate",
        method: "post",
        data: data
      });
    },
    // 更新
    updateUsed: function updateUsed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/update",
        method: "post",
        data: data
      });
    },
    // 审核
    auditUsed: function auditUsed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/audit",
        method: "post",
        data: data
      });
    },
    // 批量审核
    batchAuditUsed: function batchAuditUsed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/batchAudit",
        method: "post",
        data: data
      });
    },
    // 草稿列表
    // getDraftList(data = {}) {
    //     return request({
    //         url: "/admin/used/getDraftList",
    //         method: "get",
    //         params: data
    //     });
    // },
    // getUsedCityList(data = {}) {
    //     return request({
    //         url: "/admin/used/getCityList",
    //         method: "get",
    //         params: data
    //     });
    // },
    // 新增或者编辑广告位
    saveUsedAds: function saveUsedAds() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/ads/saveOrUpdate",
        method: "post",
        data: data
      });
    },
    // 删除广告位
    deleteUsedAds: function deleteUsedAds() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/ads/delete",
        method: "delete",
        params: data
      });
    },
    // 新增或者编辑广告位
    getUsedAdsList: function getUsedAdsList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/used/ads/list",
        method: "get",
        params: data
      });
    }
  };
});